import inMemoryCacheFactory from '@/script/cache/utils'

const configCache = 'config'
const cache = inMemoryCacheFactory(configCache)
const loadConfig = async () => {
    if (cache.loading[configCache]) return cache.loading[configCache]

    const { resolved, notfound } = cache.read([configCache])

    if (notfound.length === 0) {
        const data = resolved[configCache]
        return Promise.resolve(data)
    }

    return cache.loading[configCache] = new Promise((resolve, reject) => {
        fetch('/config.json').then(async resp => {
            if (resp.ok) {
                const config = await resp.json()
                cache.save({ [configCache]: config })
                resolve(config)
            } else {
                throw new Error(`Could not load config from /config.json`)
            }
        }).catch(err => {
            cache.stop(configCache)
            reject(err)
        })
    })
}
const config = await loadConfig()
export { config }